<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>
  <div>

    <!-- IRR drop down menu -->
    <div v-if="permissions.irrs.length" class="dropdown">
      <button class="list-group-item list-group-item-action dropdown-toggle" type="button" id="dropdownIrrSelect" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        Select a Registry
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownIrrSelect">
          <div v-for="i in permissions.irrs">
          <a class="dropdown-item" :href="'/irr/' + i.id">{{ i.name }}&nbsp;&nbsp;<span class="text-muted">({{ i.role_display_name }})</span></a>
        </div>
      </div>
    </div>

    <!-- IRR menu items -->
    <div v-if="irr" class="list-group list-group-flush">
      <a :href="baseUrls.irrBaseUrl + irr.id" role="button" class="list-group-item list-group-item-action list-group-item-info">Registry Dashboard</a>
      <a v-if="permissions.currentPermissions.IRR_CHANGE_SETTINGS" :href="baseUrls.irrBaseUrl + irr.id + '/edit'" role="button" class="list-group-item list-group-item-action list-group-item-info">Registry Settings</a>
      <a v-if="permissions.currentPermissions.IRR_GRANT_ACCESS" :href="baseUrls.irrBaseUrl + irr.id + '/users'" role="button" class="list-group-item list-group-item-action list-group-item-info">Registry Users</a>
      <!-- <a v-if="permissions.currentPermissions.IRR_GRANT_ACCESS" :href="baseUrls.irrBaseUrl + irr.id + '/accessrequests'" role="button" class="list-group-item list-group-item-action list-group-item-info">Registry Access Requests</a> -->
      <a v-if="permissions.currentPermissions.IRR_GRANT_ACCESS" :href="baseUrls.irrBaseUrl + irr.id + '/publishrequests'" role="button" class="list-group-item list-group-item-action list-group-item-info">Resource Publication Requests</a>
      <!-- <a v-if="!permissions.currentRole" :href="baseUrls.irrBaseUrl + irr.id + '/requestaccess'" role="button" class="list-group-item list-group-item-action list-group-item-info">Request Access to this Registry</a> -->
    </div>
    <h5>&nbsp;</h5>

    <!-- User/Resource menu items -->
    <div class="list-group list-group-flush">
      <a :href="baseUrls.resourceBaseUrl" role="button" class="list-group-item list-group-item-action list-group-item-warning">My Resources</a>
      <a :href="baseUrls.resourceBaseUrl + 'create/'" role="button" class="list-group-item list-group-item-action list-group-item-warning">Create Resource</a>
      <!-- <a v-if="route == 'show' && existingData.isOwner" :href="baseUrls.resourceBaseUrl + existingData.id + '/edit/'" role="button" class="list-group-item list-group-item-action list-group-item-warning">Edit Resource</a> -->
      <!-- <a v-if="route == 'show' && existingData.isOwner" :href="baseUrls.resourceBaseUrl + existingData.id + '/publish/'" role="button" class="list-group-item list-group-item-action list-group-item-warning">Resource Publishing</a> -->
      <a href="/template" role="button" class="list-group-item list-group-item-action list-group-item-warning">My Templates</a>
      <a href="/template/create" role="button" class="list-group-item list-group-item-action list-group-item-warning">Create Template</a>
      <a href="/irr-request/create" role="button" class="list-group-item list-group-item-action list-group-item-warning">Request a Registry</a>
    </div>
    <h5>&nbsp;</h5>

    <!-- Sys Admin menu items -->
    <div v-if="permissions.currentPermissions.SYS_VIEW_INFO" class="list-group list-group-flush">
      <a :href="'/irr-request/'" role="button" class="list-group-item list-group-item-action list-group-item-success">Registry Requests</a>
      <a :href="'/revoke-consent-request/'" role="button" class="list-group-item list-group-item-action list-group-item-success">Account Delete Requests</a>
      <!--<a v-if="permissions.currentPermissions.SYS_CREATE_USER" :href="'#'" role="button" class="list-group-item list-group-item-action list-group-item-success">Users</a>-->

    </div>
  </div>
</template>

<script>
    export default {
      props: {
        route: String,
        permissions: Object,
        irr: Object,
        baseUrls: Object,
        existingData: [Object, Array],
      },
      mounted(){
        //
      }
    }
</script>
